import { render, staticRenderFns } from "./InvoicesDatatable.vue?vue&type=template&id=792d946e&"
import script from "./InvoicesDatatable.vue?vue&type=script&lang=js&"
export * from "./InvoicesDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports